import React from 'react'
import { connect } from 'dva'
import { modelUtils } from '../../../../utils'
import { component_tool, framework_tool, utils_tool } from '@/tool';
import { ChartsInfo } from '../../../../components'
import { getDetailRecord } from '@/containers/content/util'
import createColumns from './columns'
import moment from 'moment';

let { WizContainer } = framework_tool
let { Session, getPageData, excelUtils } = utils_tool
let { WizSpin, WizCard, WizTabs, WizSearchBar, WizButton, WizDataTable, WizBrowserExport, WizRow, WizCol, WizTypography } = component_tool
const { Title, Text, Paragraph } = WizTypography

class PracticeRankInfo extends WizContainer {
  componentName = 'PracticeRankInfo';

  constructor(props) {
    super(props);
    this.detailInfo = getDetailRecord(props.history);
    this.state = {
      practiceId: this.detailInfo.id,
      practiceName: this.detailInfo.name,
      record: this.detailInfo
    };
    this.rankFilters = {}
    this.rankAllFilters = {}
  }

  _componentDidMount = () => {
    let { practiceId } = this.state
    this._getChartData(practiceId)
    this._getDateChartData(practiceId)
    this._getRankPageList()
  }

  /**获取图表数据*/
  _getChartData(practiceId) {
    let apiPath = "practiceRank/chartsInfo";
    this.doAction({
      path: apiPath,
      payload: {
        key: 'practiceChartsInfo',
        apiParams: { practiceId: practiceId }
      }
    })
  }
  _getDateChartData(practiceId) {
    let apiPath = "practiceRank/dateChartsInfo";
    this.doAction({
      path: apiPath,
      payload: {
        key: 'dateChartsInfo',
        apiParams: { practiceId: practiceId }
      }
    })
  }

  propsAndStateOnChange = {
    infoCharts: this._infoChartsOver.bind(this),
    dateInfoCharts: this._dateInfoChartsOver.bind(this),
    rankPageList: this._rankPageListOver.bind(this),
    rankPageDateList: this._rankPageDateListOver.bind(this),
    rankList: this._rankListOver.bind(this),
    rankDateList: this._rankDateListOver.bind(this),
  }

  /**图表数据获取情况*/
  _infoChartsOver(nextProps, nextState) {
    let data = []
    if (nextProps.infoCharts.code === 1) {
      data = nextProps.infoCharts.data
      this.chartsData = data
      return true;
    } else {
      wizNotice.error('图表数据获取失败！！')
      return false;
    }
  }
  _dateInfoChartsOver(nextProps, nextState) {
    let data = []
    if (nextProps.dateInfoCharts.code === 1) {
      data = nextProps.dateInfoCharts.data
      this.dateChartsData = data
      return true;
    } else {
      wizNotice.error('当日图表数据获取失败！！')
      return false;
    }
  }

  _rankPageListOver(nextProps, nextState) {
    let { rankPageList } = nextProps
    if (rankPageList['success']) {
      return true;
    } else {
      wizNotice.error(rankPageList['msg'] || '获取数据失败，请稍后再试')
    }
    return false
  }

  _rankPageDateListOver(nextProps, nextState) {
    let { rankPageDateList } = nextProps
    if (rankPageDateList['success']) {
      return true;
    } else {
      wizNotice.error(rankPageDateList['msg'] || '获取数据失败，请稍后再试')
    }
    return false
  }

  _rankListOver(nextProps, nextState) {
    let columnDefs = [
      {
        headerName: '',
        width: 30,
        field: 'rowIndex',
        hidden: true,
        suppressMovable: true,
        cellStyle: {
          textAlign: 'left',
          padding: '5px 0',
          color: '#595959',
          backgroundColor: '#f0f0f0',
          display: 'inline-flex',
          fontWeight: '500',
          boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)',
        },
      },
      {
        headerName: '日期',
        field: 'practiceDate',
        width: 20,
      },
      {
        headerName: '参与用户(人)',
        field: 'participantNum',
        width: 20,
      },
      {
        headerName: '未参与用户(人)',
        field: 'nonParticipantNum',
        width: 20,
      },
      {
        headerName: '参与人次',
        field: 'participantCount',
        width: 20,
      },
    ]
    if (nextProps.rankList.code === 1) {
      let {practiceName} = nextState
      let data = nextProps.rankList.data
      WizBrowserExport({
        title: `${practiceName}-排行`,
        sheetName: `${practiceName}-排行`,
        columns: columnDefs.filter((_, index) => index),
        rows: data,
        filename: `${practiceName}-排行.xlsx`,
      })
      return true;
    } else {
      wizNotice.error('获取导出数据失败')
      return false;
    }
  }

  _rankDateListOver(nextProps, nextState) {
    let columnDefs = [
      {
        headerName: '',
        width: 30,
        field: 'rowIndex',
        hidden: true,
        suppressMovable: true,
        cellStyle: {
          textAlign: 'center',
          padding: '5px 0',
          color: '#595959',
          backgroundColor: '#f0f0f0',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: '500',
          boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)'
        }
      },
      {
        headerName: '总排名',
        field: 'rank',
        width: 10
      },
      {
        headerName: '姓名',
        field: 'fullName',
        width: 20
      },
      {
        headerName: '账号',
        field: 'userName',
        width: 20
      },
      {
        headerName: '账号状态',
        field: 'accountState',
        width: 20,
      },
      {
        headerName: '任职信息',
        field: 'userIdentityInfoListStr',
        width: 35
      },
      {
        headerName: '练习天数',
        field: 'days',
        width: 10
      },
      {
        headerName: '练习次数',
        field: 'count',
        width: 10
      },
      {
        headerName: '平均正确率',
        field: 'avgAccuracy',
        width: 20
      },
      {
        headerName: '最优正确率',
        field: 'maxAccuracy',
        width: 20
      },
      {
        headerName: '平均练习时长(秒)',
        field: 'avgDuration',
        width: 20
      },
    ]
    if (nextProps.rankDateList.code === 1) {
      let data = nextProps.rankDateList.data
      data && data.length && data.forEach(d=>{
        if (d.userIdentityInfoList && d.userIdentityInfoList.length){
          let userIdentityInfoListStr = '';
          d.userIdentityInfoList.forEach(_d => {
            if (userIdentityInfoListStr===''){
              userIdentityInfoListStr = _d.positionName+' - '+_d.orgName;
            }else {
              userIdentityInfoListStr = userIdentityInfoListStr +'、'+ _d.positionName+' - '+_d.orgName;
            }
          })
          d['userIdentityInfoListStr']=userIdentityInfoListStr;
        }
        if (d.accountState!=null){
          d['accountState']=d.accountState===1 ? '激活':'禁用';
        }
        d.avgAccuracy = d.avgAccuracy + '%'
        d.maxAccuracy = d.maxAccuracy + '%'
      })
      WizBrowserExport({
        title: '练习总排行',
        sheetName: '练习总排行',
        columns: columnDefs.filter((_, index) => index),
        rows: data,
        filename: '练习总排行.xlsx',
      })
      return true;
    } else {
      wizNotice.error('获取导出数据失败')
      return false;
    }
  }

  changeTab = (e) => {
    if (e === '1') {
      this._getRankPageList()
    } else if (e === '2') {
      this._getAllRankPageList()
    }
  }

  _getRankPageList(apiParams = {}) {
    let { practiceId } = this.state
    this.doAction({
      path: 'practiceRank/list',
      payload: {
        key: 'rankPageList',
        apiParams: {
          practiceId: practiceId,
          ...apiParams
        }
      }
    })
  }

  _getAllRankPageList(apiParams = {}) {
    let { practiceId } = this.state
    this.doAction({
      path: 'practiceRank/rankList',
      payload: {
        key: 'rankPageDateList',
        apiParams: {
          practiceId: practiceId,
          ...apiParams
        }
      }
    })
  }

  _getRankList(apiParams = {}) {
    let { practiceId } = this.state
    this.doAction({
      path: 'practiceRank/export',
      payload: {
        key: 'rankList',
        apiParams: {
          practiceId: practiceId,
          ...apiParams
        }
      }
    })
  }

  _getAllRankList(apiParams = {}) {
    let { practiceId } = this.state
    this.doAction({
      path: 'practiceRank/rankExport',
      payload: {
        key: 'rankDateList',
        apiParams: {
          practiceId: practiceId,
          ...apiParams
        }
      }
    })
  }

  _onSelect(keys, rows) {
    this.setState({
      keys,
      rows,
      selectedRows: keys.length
    })
  }

  _renderBtn = (type) => {
    let r = []
    let btns = new Map();
    btns.set('export',
      <WizButton title="导出"
        type="export"
        onClick={() => {
          if (type === 'rank') {
            this._getRankList(this.rankFilters)
          }
          if (type === 'allRank') {
            this._getAllRankList(this.rankAllFilters)
          }
        }}
        icon="export"
        style={{ marginBottom: 15 }}>导出</WizButton>
    );
    let btnCode = this.getMenuBtn() || [];
    btnCode.map(({ code }) => {
      if (btns.has(code)) {
        r.push(btns.get(code))
      }
    })
    return r
  }

  renderRecordInfo = (type) => {
    let { rankPageList, rankPageDateList, practiceRankLoading } = this.props
    let columns = createColumns(this, type)
    let pageList = type === 'rank' ? rankPageList : rankPageDateList
    let list = getPageData(pageList && pageList.data)
    let searchBarProps = {
      columns,
      collapse: false,
      onSearch: values => {
        let params = Object.assign({}, values)
        if (params.practiceDate && params.practiceDate.length === 2) {
          params.startDate = moment(params.practiceDate[0]).format('YYYY-MM-DD')
          params.endDate = moment(params.practiceDate[1]).format('YYYY-MM-DD')
        } else {
          params.startDate = null
          params.endDate = null
        }
        params.practiceDate = null
        if (type === 'rank') {
          this.rankFilters = params
          this._getRankPageList(params)
        }
        if (type === 'allRank') {
          this.rankAllFilters = params
          this._getAllRankPageList(params)
        }
      }
    }
    let dataTableProps = {
      loading: practiceRankLoading,
      columns,
      rowKey: 'id',
      dataItems: list,
      isScroll: true,
      onChange: ({ pageNum, pageSize }) => {
        if (type === 'rank') {
          this._getRankPageList({ current: pageNum, size: pageSize, ...this.rankFilters })
        }
        if (type === 'allRank') {
          this._getAllRankPageList({ current: pageNum, size: pageSize, ...this.rankAllFilters })
        }
      },
      onSelect: (keys, rows) => this._onSelect(keys, rows)
    }
    return (
      <WizSpin tip={'加载中'} spinning={practiceRankLoading}>
        <div className='pagination'>
          <WizSearchBar key="practiceRank_searchBar" type="grid" {...searchBarProps} />
        </div>
        {this._renderBtn(type)}
        <WizDataTable key={'practiceRank_dataTable'} {...dataTableProps} />
        <div className='pagination'>
          <WizDataTable.Pagination key={'practiceRank_pagination'} {...dataTableProps} />
        </div>
      </WizSpin>
    )
  }

  _onLook = (record) => {
    let {practiceName} = this.state
    record.practiceName = practiceName
    this.jumpPage('push', '/online/practice/rank/date', record)
  }

  _renderContentRow(ln, lv = '', rn, rv = '') {
    return (
      <WizRow className='administrationScope-row-item'>
        <WizCol className='col-item' span={3} offset={1}><Text strong>{ln + '：'}</Text></WizCol>
        <WizCol span={6}><Text strong>{lv}</Text></WizCol>
        <WizCol className='col-item' span={3} offset={2}><Text strong>{rn + '：'}</Text></WizCol>
        <WizCol span={9}><Text strong>{rv}</Text></WizCol>
      </WizRow>
    )
  }
  _chartsHead = (record) => {
    let chartsHead = []
    if (record?.id) {
      chartsHead = ['练习名称', record.name, '练习时间', record.startDate + ' ~ ' + record.endDate]
    }
    return this._renderContentRow(chartsHead[0], chartsHead[1], chartsHead[2], chartsHead[3])
  }

  _render() {
    let londing = this.props.practiceRankLoading || this.props.practiceRankLoading
    let { record } = this.state

    let chartsHead = []
    if (record?.id) {
      chartsHead = ['练习名称', record.name, '练习时间', record.startDate + ' ~ ' + record.endDate]
    }
    let practicePrecent = this.chartsData ? <ChartsInfo
      percentProps={{
        key : 'practicePrecent',
        data: [
          {
            item: "已参与人数",
            count: this.chartsData.practiceNumCount,
          },
          {
            item: "未参与人数",
            count: this.chartsData.practiceNotNumCount,
          }
        ],
        dataFormat: {
          type: "percent",
          field: "count",
          dimension: "item",
          as: "percent"
        },
        count: this.chartsData.practiceNum,
        centerText: '总练习概况',
        colors:['rgb(0,157,255)','#22E4FFFF']
      }}
    /> : null

    let datePracticePrecent = this.dateChartsData ? <ChartsInfo
      percentProps={{
        key : 'datePracticePrecent',
        data: [
          {
            item: "已参与人数",
            count: this.dateChartsData.practiceNumCount,
          },
          {
            item: "未参与人数",
            count: this.dateChartsData.practiceNotNumCount,
          }
        ],
        dataFormat: {
          type: "percent",
          field: "count",
          dimension: "item",
          as: "percent"
        },
        count: this.dateChartsData.practiceNum,
        centerText: '日练习概况',
        colors:['rgb(71,145,213)','rgb(34,233,144)']
      }}
    /> : null
    return (
      <>
        <WizSpin tip={"加载中"} spinning={londing}>
          <WizCard title={'练习概况'}>
            {this._chartsHead(record)}
            <WizRow>
              <WizCol span={12}>{practicePrecent}</WizCol>
              <WizCol>{datePracticePrecent}</WizCol>
            </WizRow>
          </WizCard>
          <WizCard>
            <WizTabs defaultActiveKey="1" onChange={this.changeTab}>
              <WizTabs.TabPane tab={'日排行'} key="1">
                {this.renderRecordInfo('rank')}
              </WizTabs.TabPane>
              <WizTabs.TabPane tab={'总排行'} key="2">
                {this.renderRecordInfo('allRank')}
              </WizTabs.TabPane>
            </WizTabs>
          </WizCard>
        </WizSpin>
      </>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const { practiceRank } = state;
  const infoCharts = modelUtils.getModelEntity(practiceRank, 'practiceChartsInfo')
  const dateInfoCharts = modelUtils.getModelEntity(practiceRank, 'dateChartsInfo')
  const rankPageList = modelUtils.getModelEntity(practiceRank, 'rankPageList')
  const rankPageDateList = modelUtils.getModelEntity(practiceRank, 'rankPageDateList')
  const rankList = modelUtils.getModelEntity(practiceRank, 'rankList')
  const rankDateList = modelUtils.getModelEntity(practiceRank, 'rankDateList')
  const load = modelUtils.getLoadingState(state, ['practiceRank']);
  return {
    infoCharts,
    dateInfoCharts,
    rankPageList,
    rankPageDateList,
    rankList,
    rankDateList,
    ...load
  }

};

export default connect(mapStateToProps)(PracticeRankInfo);
